import { useIntl } from 'react-intl';
import { getIDFromUrl, Url } from '@rossum/api-client';
import { EmptyState } from '@rossum/components/empty-state/EmptyState';
import { Tile, TileSkeleton } from '@rossum/components/tile';
import { Stack } from '@rossum/ui/material';
import { extensionDetailPath } from '../../extensions/routes';
import { useGetCredentialHooks } from '../core/hooks';

type CredentialExtensionsListProps = {
  hooks: Url[];
};

export const CredentialExtensionsList = ({
  hooks,
}: CredentialExtensionsListProps) => {
  const intl = useIntl();
  const ids = hooks.map(getIDFromUrl);
  const { data, isInitialLoading, isError } = useGetCredentialHooks(ids);

  return (
    <Stack spacing={1} useFlexGap>
      {isInitialLoading ? (
        [1, 2].map(no => (
          <TileSkeleton key={no} skeletons={['title', 'description']} hasTo />
        ))
      ) : isError ? (
        <EmptyState
          title={intl.formatMessage({
            id: 'features.credentials.form.extensions.error.title',
          })}
          description={intl.formatMessage({
            id: 'features.credentials.form.extensions.error.description',
          })}
        />
      ) : data && data.length > 0 ? (
        data.map(hook => (
          <Tile
            key={hook.id}
            title={hook.name}
            description={hook.description}
            to={extensionDetailPath(hook.id)}
          />
        ))
      ) : (
        <EmptyState
          title={intl.formatMessage({
            id: 'features.credentials.form.extensions.empty.title',
          })}
          description={intl.formatMessage({
            id: 'features.credentials.form.extensions.empty.description',
          })}
        />
      )}
    </Stack>
  );
};
